import { createApp, watch } from 'vue'
import ArcoVue from '@arco-design/web-vue'
import ArcoVueIcon from '@arco-design/web-vue/es/icon'
import App from './App.vue'
import router from './router/index'
import setupPinia, { useUserStore } from './store/index'
import i18n from './locales'
import '@arco-themes/vue-vm-ai/index.less'
import './assets/style/main.less'
import 'virtual:uno.css'
import 'mathlive/static.css'
import directive from './directive'
import { getCurrentUserDetail } from './api/modules/user'
import { GLOBAL_WS_CHANNEL, initGlobalWebSocket, setGlobalWebSocketAuth, subscribeGlobalWebSocketChannel } from './api/modules/globalWebsocket'
const app = createApp(App)

app.use(ArcoVue)
app.use(ArcoVueIcon)
app.use(router)
app.use(i18n)
app.use(directive)
setupPinia(app)


function getTokenFromUrl(): string | null {
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('token')) {
    return searchParams.get('token')
  }

  const hash = window.location.hash
  if (hash.includes('?')) {
    const hashParams = new URLSearchParams(hash.split('?')[1])
    return hashParams.get('token')
  }

  return null
}


function initToken() {
  const token = getTokenFromUrl()
  if (token) {
    useUserStore().setToken(token)
  }
  getUserInfo()
}

async function getUserInfo() {
  const { success, content } = await getCurrentUserDetail()
  if(success) {
    useUserStore().setUserInfo(content)
  }
}

function setupGlobalWebSocketLifecycle() {
  const userStore = useUserStore()
  initGlobalWebSocket()
  watch(() => ({
    token: userStore.token,
    studentId: userStore.userInfo?.userId
  }), auth => {
    setGlobalWebSocketAuth(auth)
  }, { immediate: true })
}

initToken()

app.mount('#app')
router.isReady().then(() => {
  setupGlobalWebSocketLifecycle()
})
